import { RadioCardProps as MantineRadioCardProps, RadioMantine } from '../../../../Inputs';
import { Flex, Stack } from '../../../../Layout';
import { Box } from '../../../../Miscellaneous/Box';
import { cx } from '../../../../Provider/Provider';
import { Text } from '../../../../Typography';
import classes from './RadioCard.module.css';

interface RadioCardProps extends MantineRadioCardProps {
  position?: 'left' | 'right';
  title?: string;
  description?: string;
  onChange?: () => void;
  indicator?: React.ReactNode;
  error?: boolean;
  contentClassName?: string;
}

const RadioCard = ({
  className,
  position = 'left',
  title,
  description,
  disabled,
  indicator,
  error,
  contentClassName,
  ...rest
}: RadioCardProps) => {
  return (
    <RadioMantine.Card
      className={cx(classes.RadioCard, className)}
      mod={{
        disabled,
        error,
      }}
      {...rest}
    >
      <Flex className={cx(classes.RadioCard__contents, contentClassName)} mod={{ position }}>
        {indicator ? (
          <Box flex={1}>{indicator}</Box>
        ) : (
          <RadioMantine.Indicator disabled={disabled} />
        )}
        <Stack gap={4}>
          {title && <Text className={classes.RadioCard__title}>{title}</Text>}
          {description && (
            <Text className={classes.RadioCard__description} mod={{ 'has-title': !!title }}>
              {description}
            </Text>
          )}
        </Stack>
      </Flex>
    </RadioMantine.Card>
  );
};

export { RadioCard };
